export const BUILTIN_ACTIONS = [
  'find',
  'findAll',
  'create',
  'update',
  'updateAll',
  'destroy',
  'destroyAll',
];

export const BUILTIN_WRITE_ACTIONS = [
  'create',
  'update',
  'updateAll',
  'destroy',
  'destroyAll',
];
